/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 */

document.addEventListener("DOMContentLoaded", function () {
  const brandingElement = document.querySelector('.pmpr__branding_link');
  if (brandingElement) {
    brandingElement.style.display = 'none';
  }
});



const hideBranding = () => {
  const brandingElement = document.querySelector('.pmpr__branding_link');
  if (brandingElement) {
    brandingElement.style.display = 'none';
  }
};

// Tenta ocultar após o carregamento da página e verifica de tempos em tempos
document.addEventListener("DOMContentLoaded", hideBranding);
setInterval(hideBranding, 1000); // Tenta novamente a cada segundo







